import React, { useEffect } from "react";
import "../App.css";
import Header from "./Header";
import HeroImage from "./HeroImage";
import LocationDetails from "./LocationDetails";
import useSanityPage from "../lib/useSanityPage";

export default function App() {
  const { page } = useSanityPage("maynooth-home", "maynooth")

  useEffect(() => {
    // Only show popup once per session
    const hasSeenPopup = sessionStorage.getItem("hasSeenPopup");

    if (!hasSeenPopup) {
      const timer = setTimeout(() => {
        const modalElement = document.getElementById("welcomeModal");
        if (modalElement) {
          const modal = new (window as any).bootstrap.Modal(modalElement);
          modal.show();
          sessionStorage.setItem("hasSeenPopup", "true");
        }
      }, 2000); // 2-second delay

      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className="bg-light text-dark text-center">
      <Header />
      <HeroImage hero={page?.hero} />
      <LocationDetails />
      {/* <Popup /> */}
    </div>
  );
}


